import { defineComponent as _defineComponent } from 'vue'
import BCXCheckbox from '@/components/molecules/forms/BCXCheckbox.vue';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import BCXTagSelectAdd from '@/components/tagging/BCXTagSelectAdd.vue';
import TagEntry from '@/components/tagging/TagEntry.vue';
import type { Tag } from '@/services/TaggingService';
import useUser from '@/mixins/useUser';
import {
  computed, ComputedRef, ref, watch
} from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import taggingService from '@/services/TaggingService';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionManagerTag',
  props: {
    isInlineHelpOpened: { type: Boolean }
  },
  emits: ["update:isInlineHelpOpened"],
  setup(__props: any, { emit }: { emit: ({(e: 'update:isInlineHelpOpened', value: boolean): void }), expose: any, slots: any, attrs: any }) {





const store = useStore();
const { tUserFallback: t } = useUser('self');
const isMobileLayout = computed(() => store.getters['page/isMobileLayout']);
const heuristicEnabled: ComputedRef<boolean> = computed(() => store.state.subscriptions.allTagSettings?.heuristic ?? true);
const tagValue = ref('');
const showSuggestions = ref(false);
const selectedTag = ref<Tag | null>(null);
const relatedTags = ref<Tag[]>([]);
const truncatedRelatedTags = computed(() => relatedTags.value.slice(0, isMobileLayout.value ? 8 : 8));

function onCheckHeuristics(value: boolean) {
  store.dispatch('subscriptions/updateAllTagSettings', { heuristic: value });
}

const onSelect = (tag: Tag) => {
  selectedTag.value = tag;
};

const onDeleteSelection = () => {
  showSuggestions.value = false;
  selectedTag.value = null;
  tagValue.value = '';
  relatedTags.value = [];
};

const updateInlineHelp = (value: boolean) => {
  emit('update:isInlineHelpOpened', value);
};

watch(selectedTag, async (newTag) => {
  if (!newTag) {
    showSuggestions.value = false;
    return;
  }

  if (!heuristicEnabled.value) {
    const tag = await taggingService.getTag(newTag.tagId);
    relatedTags.value = tag?.relatedTagList ?? [];
  }

  showSuggestions.value = true;
});

return { __sfc: true,emit, store, t, isMobileLayout, heuristicEnabled, tagValue, showSuggestions, selectedTag, relatedTags, truncatedRelatedTags, onCheckHeuristics, onSelect, onDeleteSelection, updateInlineHelp, BCXCheckbox, BCXHelpTextTriggerIcon, BCXTagSelectAdd, TagEntry }
}

})